import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export default function WelcomeFinalCTA() {
  return (
    <section className="wl-final wl-section--rule" aria-labelledby="wl-final-title">
      <div className="wl-container" style={{ maxWidth: 860 }}>
        <div className="wl-eyebrow">Access</div>
        <h2 id="wl-final-title" className="wl-h2">
          See IntelliSecure against <em>your</em> threat landscape.
        </h2>
        <p className="wl-lede">
          Your IntelliSecure representative sets up your organization with a detailed profile,
          so your Inbox fills with the campaigns that match your sector, region and technology.
        </p>
        <div className="wl-cta-row">
          <Link to="/register" className="wl-btn wl-btn--primary">
            Request access
            <ArrowRight aria-hidden="true" />
          </Link>
          <Link to="/login" className="wl-btn wl-btn--ghost">Sign in</Link>
        </div>
      </div>
    </section>
  );
}
